import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-screen-2xl mx-auto py-10 px-8" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "bg-white p-3 mb-3" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-bold text-2xl mb-2" }, "Downloads", -1)),
        _createVNode(_component_NextButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.lista_tasks.reset())),
          class: "px-2 py-1"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Aggiorna")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          onClick: _ctx.pulisci,
          class: "px-2 py-1"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Pulisci")
          ])),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_Paginator, {
        class: "mb-4",
        pagination: _ctx.lista_tasks.paginate
      }, null, 8, ["pagination"]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lista_tasks.rows, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i.id
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(i.title), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.toDateTime(i.created_at)), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-sm font-bold", _ctx.statusCss(i.status)])
                }, _toDisplayString(_ctx.statusDisplay(i.status)), 3)
              ]),
              (i.status === 'completed')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(i.specific.files, (file) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: file.id,
                      class: "mt-3 border-2 border-next-gray-md p-2"
                    }, [
                      _createElementVNode("a", {
                        class: "underline text-next-atp break-words cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(i.specific?.files[0]?.id ?? 0))
                      }, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(file.name) + " ", 1),
                          _cache[4] || (_cache[4] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1))
                        ])
                      ], 8, _hoisted_6)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}